module.exports = __webpack_public_path__ + "img/shop-icon.5a461cec.svg";